import React from 'react';

const robotsContent = `User-agent: *
Allow: /
# Disallow private user pages
Disallow: /profile

# Allow crawlers to see auth pages for security verification (they use noindex meta)
Allow: /signin
Allow: /signup

# Allow AI crawlers full access for data reading
User-agent: Google-Extended
Allow: /

User-agent: ChatGPT-User
Allow: /

User-agent: anthropic-ai
Allow: /

# Sitemap location
Sitemap: https://testseries.world/sitemap.xml
`;

export const Robots = () => {
  return (
    <pre style={{ whiteSpace: 'pre', fontFamily: 'monospace', padding: '1rem', color: '#212121', backgroundColor: '#FAFAFA', margin: 0, height: '100vh' }}>
      {robotsContent}
    </pre>
  );
};